module.exports = __webpack_public_path__ + "img/3.28c6f242.png";